<template>
  <div class="container" v-show="isShow">
    <a class="popup-close-button" @click="showSystemInfo">x</a>
    <div class="content">
        <el-input class="systemInfos" type="textarea" autosize v-model="infos"></el-input>
    </div>
  </div>
</template>

<script>
export default {
    name:'DisplaySystemInfos',
    data(){
        return {
            ws:'',
            infos:'',
            textRows: 0,
            isShow:false
        }
    },
    methods: {
        showSystemInfo(){
            this.isShow = !this.isShow ;
        }
    },
    mounted(){
        var url = "ws://47.111.99.118:32769";
        console.log('DisplaySystemInfos 组件,url =',url);
        this.ws = new WebSocket(url);

        this.ws.onopen = () =>{
            // Web Socket 已连接上，使用 send() 方法发送数据
            this.ws.send("发送数据");
            // alert("数据发送中...");
        };
        console.log('DisplaySystemInfos 组件,this.ws =',this.ws,this);
        this.ws.onmessage = (evt) => {
            // console.log('DisplaySystemInfos 组件,evt =',evt)
            var received_msg = evt.data;
            var fdStart = received_msg.indexOf("rtStatus");
            if(fdStart == 0){
               
            }else if(fdStart == -1){
                this.infos = received_msg ;
                // console.log('DisplaySystemInfos 组件,this.infos =',this.infos)
            }            
            // alert("数据已接收...");
        };

        this.$bus.on('showSystemInfo',this.showSystemInfo);
    },
    beforeUnmount() {
        this.ws.onclose = function() {
            this.infos = "ws连接已关闭...";
            // this.ws = new WebSocket(url);
        };
    },
}
</script>

<style scoped>
.container{
    position: absolute;
    width: 350px;
    height: 590px;
    top: 1%;
    left: 75%;
    border: 2px solid wheat;
    background-color: rgba(0, 0, 0, 0.7);
    border-radius: 10px;
    padding: 10px;
    /* color: white; */
    
}
.systemInfos{
    width: 100%;
    height: 100%;
    overflow: scroll;
    background-color: transparent !important;
    /* border: 0px; */
    font-size: 1.2em;
    /* color: black; */
}

.content{
    margin-top: 5%;
    width: 100%;
    height: 97%;
    border-radius: 5px;
    overflow: hidden;
}
.popup-close-button {
    position: absolute;
    top: 0;
    right: 14px;
    padding: 5px 10px 0 0;
    text-align: center;
    width: 18px;
    height: 14px;
    font: 20px/16px Tahoma, Verdana, sans-serif;
    text-decoration: none;
    font-weight: 700;
    background: transparent;
    z-index: 9999;
    color: aliceblue;
  }

  .popup-close-button:hover {
    cursor: pointer;
    color: red;
  }
</style>